<div>
  <a href="javascript:void(0)" #btnPrev id="btnPrev" [class.disabled]="prevDisabled" [tabindex]="prevDisabled ? -1 : 0"
    (click)="onPrevClick()" (keydown.Space)="onPrevClick()" (keydown)="onKeydown($event)">
    <fa-icon [icon]="iconPrev" ngbTooltip="前へ"></fa-icon>
  </a>
  <label [style.text-align]="'right'" id="lbl_TotalNum">{{totalNum}}</label>
  <label>件中</label>
  <label [style.text-align]="'right'" id="lbl_StartDispNum">{{startNum}}</label>
  <label>～</label>
  <label [style.text-align]="'right'" id="lbl_EndDispNum">{{endNum}}</label>
  <label>件表示</label>
  <a href="javascript:void(0)" #btnNext id="btnNext" [class.disabled]="nextDisabled" [tabindex]="nextDisabled ? -1 : 0"
    (click)="onNextClick()" (keydown.Space)="onNextClick()" (keydown)="onKeydown($event)">
    <fa-icon [icon]="iconNext" ngbTooltip="次へ"></fa-icon>
  </a>
</div>